import { dequal } from 'dequal';
import { cloneDeep } from 'es-toolkit/compat';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function shallowDiff<TUpdated extends Record<string, any>>(
  updates: Partial<TUpdated>,
  original: TUpdated | undefined,
): Partial<TUpdated> {
  if (original == null) return updates;
  let diff: Partial<TUpdated> = {};
  for (const [key, value] of Object.entries(updates) as Array<
    [keyof TUpdated, TUpdated[keyof TUpdated]]
  >) {
    if (!dequal(value, original[key])) {
      // Clone only when it's required
      if (diff === updates) diff = { ...updates };
      diff[key] = value;
    }
  }
  return diff;
}

export function tryParseJSON<T>(json: string): T | undefined {
  try {
    return JSON.parse(json) as T;
  } catch {
    return undefined;
  }
}

export function tryStringifyJSON<T>(data: T): string | undefined {
  try {
    return JSON.stringify(data);
  } catch {
    return undefined;
  }
}

export function deepClone<T>(value: T): T {
  if (typeof structuredClone !== 'undefined') {
    try {
      return structuredClone(value);
    } catch (error) {
      if (error != null && typeof error === 'object') {
        return cloneDeep(value);
      }
      throw error;
    }
  }
  return cloneDeep(value);
}

export function arrayMove<T>(array: T[], from: number, to: number) {
  const newArray = Array.from(array);
  newArray.splice(to, 0, ...newArray.splice(from, 1));
  return newArray;
}
